import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

import Typography from 'components/Main/Typography';
import PrimaryButton from 'components/Buttons/PrimaryButton';

const useStyles = makeStyles(theme => ({
	container: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		padding: '20px 24px',
		borderRadius: 3,
		borderLeft: `4px solid ${theme.palette.error.main}`,
		backgroundColor: theme.palette.error.light,

		'& > * + *': {
			marginTop: 12,
		},
	},
	title: {
		color: theme.palette.error.dark,
	},
	message: {
		color: theme.palette.text.primary,
	},
}));

/**
 * Shown in place of a listing that could not be loaded, so a failed request is
 * never mistaken for an empty result.
 *
 * @param {Object} props
 * @param {string} [props.message] Reason returned by the API.
 * @param {Function} [props.onRetry] Repeats the request that failed.
 */
const LoadError = ({ message, onRetry }) => {
	const classes = useStyles();

	return (
		<div className={classes.container} role="alert">
			<Typography variant="bodyL" className={classes.title}>
				Nie udało się pobrać danych
			</Typography>

			{message && (
				<Typography className={classes.message}>{message}</Typography>
			)}

			{onRetry && (
				<PrimaryButton onClick={onRetry}>Spróbuj ponownie</PrimaryButton>
			)}
		</div>
	);
};

LoadError.propTypes = {
	message: PropTypes.string,
	onRetry: PropTypes.func,
};

export default LoadError;
